import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { seeFollowersList, seeFollowingList } from '../../actions/friendsActions'
import ListSocial from '../../containers/Profile/ListSocial/ListSocial'

const SocialList = ({ location }) => {
    const dispatch = useDispatch()
    const {followersList,followingList} = useSelector(state=>state.userInfo)
    const [type, setType] = useState({
        listName: "",
        listSocial: []
    })


    useEffect(() => {
        if (location.pathname.includes("Followers")) {
            dispatch(seeFollowersList(1))
        }
        if (location.pathname.includes("Followed")) {
            dispatch(seeFollowingList(1))
        }

        if (location.pathname.includes("FriendList")) {

        }
        
    }, [])
    useEffect(() => {
        if (location.pathname.includes("Followers")) {
           setType({
            listName:"Seguidores",
            listSocial:followersList || []
           })
        }
        if (location.pathname.includes("Followed")) {
            setType({
                listName:"Seguidos",
                listSocial:followingList || []
               })
        }

        if (location.pathname.includes("FriendList")) {

        }
        
    }, [followersList,followingList])
    return (
        <ListSocial
            iduser={""}
            listSocial={type.listSocial}
            listName={type.listName}
        />
    )
}

export default SocialList